export const PURCHASE_BUTTON_IMAGE_URL =
  'https://cdn.xsolla.net/image-proxy/rs:fit:1920:0/f:webp/storage/merchant-bucket-prod/files/uploaded/sitebuilder/439172/278351b94c153d7a031eba9650ab1fa7.png@webp';

export const OPACITY = {
  DISABLED: 0.5,
  FADED: 0.8,
} as const;
